<template>
  <ion-tab-bar mode="md">
    <ion-tab-button tab="main" href="/tabs/main" :selected="select == 'main'">
      <ion-icon :icon="ticket" />
      <ion-label>Vé số</ion-label>
    </ion-tab-button>

    <ion-tab-button tab="live" href="/tabs/live" :selected="select == 'live'">
      <ion-icon :src="require('../images/ui/live.svg')" />
      <ion-label>Trực tiếp</ion-label>
    </ion-tab-button>

    <ion-tab-button tab="results" href="/tabs/results" :selected="select == 'results'">
      <ion-icon :icon="trophy" />
      <ion-label>Kết quả</ion-label>
    </ion-tab-button>

    <ion-tab-button tab="stats" href="/tabs/stats" :selected="select == 'stats'">
      <ion-icon :icon="statsChart" />
      <ion-label>Thống kê</ion-label>
    </ion-tab-button>

    <ion-tab-button tab="menu" href="/tabs/menu" :selected="select == 'menu'">
      <ion-icon :icon="menu" />
      <ion-label>Thông tin</ion-label>
    </ion-tab-button>
  </ion-tab-bar>
</template>

<style>

</style>

<script>
  import {
    IonTabBar,
    IonTabButton,
    IonLabel,
    IonIcon,
  } from '@ionic/vue';
  import { trophy, reload, ticket, menu, statsChart } from 'ionicons/icons';
  import { defineComponent } from 'vue';

  export default defineComponent({
    name: 'TabBar',
    props: ['select'],
    components: {
      IonTabBar,
      IonTabButton,
      IonLabel,
      IonIcon,
    },
    setup() {
      return {
        trophy,
        reload,
        ticket,
        menu,
        statsChart,
      }
    }
  })
</script>
